import { FC } from 'react';
import { InlineFeedbackDropdown } from '../ThreadedInteraction/feedback/FeedbackDropdown';
import { TaskHeader } from '@scale/scaleui';

type IconInlineFeedbackProps = {
  isDefaultOpen?: boolean;
  isChatTaskWithComments?: boolean;
  visible?: boolean;
  userId?: string;
  isNewHeader?: boolean;
  enableUnifiedFeedback?: boolean;
};

export const IconInlineFeedback: FC<IconInlineFeedbackProps> = ({
  isDefaultOpen,
  isChatTaskWithComments,
  visible,
  userId,
  isNewHeader,
  enableUnifiedFeedback,
}) => {
  if (!isChatTaskWithComments) return null;
  return (
    <InlineFeedbackDropdown
      dropdownAlignment={isNewHeader ? 'middle' : 'right'}
      isDefaultOpen={!!isDefaultOpen}
      badgeClasses="!-translate-y-[6px] !translate-x-[5px]"
      renderButton={({ onClick }) => (
        <TaskHeader.IconHandlerItem
          icon={[isNewHeader ? 'fas' : 'far', 'comment-alt']} // TODO: implement selected for isOpen
          onClick={onClick}
          label="Task Feedback"
          visible={visible}
        />
      )}
      userId={userId}
      enableUnifiedFeedback={enableUnifiedFeedback}
    />
  );
};
